module.exports = __webpack_public_path__ + "static/media/lars.a10df98f.png";